import Api from 'src/api/Base'

class GetSpaceTypes extends Api {
  requestUrl = `/api/spaceType`
}

export default GetSpaceTypes
